'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _get2 = require('lodash/get');

var _get3 = _interopRequireDefault(_get2);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class, _desc, _value, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _class3, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mobx = require('mobx');

var _mobxReact = require('mobx-react');

var _classAutobindDecorator = require('class-autobind-decorator');

var _classAutobindDecorator2 = _interopRequireDefault(_classAutobindDecorator);

var _Button = require('react-bootstrap/lib/Button');

var _Button2 = _interopRequireDefault(_Button);

var _ButtonToolbar = require('react-bootstrap/lib/ButtonToolbar');

var _ButtonToolbar2 = _interopRequireDefault(_ButtonToolbar);

var _SmartBool = require('../../utils/SmartBool');

var _SmartBool2 = _interopRequireDefault(_SmartBool);

var _common = require('../common');

var _mightyFields = require('../../lib/mighty-fields');

var _constants = require('../../../src/constants');

var _ChangeOwnersModal = require('./ChangeOwnersModal');

var _ChangeOwnersModal2 = _interopRequireDefault(_ChangeOwnersModal);

var _ChangeTrackingContactModal = require('./ChangeTrackingContactModal');

var _ChangeTrackingContactModal2 = _interopRequireDefault(_ChangeTrackingContactModal);

var _CloseAllLiensModal = require('./CloseAllLiensModal');

var _CloseAllLiensModal2 = _interopRequireDefault(_CloseAllLiensModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  Object.defineProperty(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var PERMISSIONS = _constants.AppConstants.PERMISSIONS;


var FIELD_SETS_CASE_SHARING_DROPDOWN = [[{
  field: 'migrate_to_registry',
  label: 'Share this case with the associated law firm',
  type: 'requiredBoolean'
}]];

var CaseTrackingHeader = (_dec = (0, _mobxReact.inject)('Clients', 'SessionStore', 'FunderStore'), _dec(_class = (0, _classAutobindDecorator2.default)(_class = (0, _mobxReact.observer)(_class = (_class2 = (_temp2 = _class3 = function (_Component) {
  _inherits(CaseTrackingHeader, _Component);

  function CaseTrackingHeader() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, CaseTrackingHeader);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CaseTrackingHeader.__proto__ || Object.getPrototypeOf(CaseTrackingHeader)).call.apply(_ref, [this].concat(args))), _this), _initDefineProp(_this, 'isChangeFollowupModalVisible', _descriptor, _this), _initDefineProp(_this, 'isSharingStatusModalVisible', _descriptor2, _this), _initDefineProp(_this, 'isCloseAllLiensModalVisible', _descriptor3, _this), _initDefineProp(_this, 'isChangeOwnersModalVisible', _descriptor4, _this), _initDefineProp(_this, 'isChangeTrackingContactModalVisible', _descriptor5, _this), _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(CaseTrackingHeader, [{
    key: 'bulkUpdateCaseData',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(data) {
        var _props, selectedRows, fetchTableData, Clients, bulkData;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _props = this.props, selectedRows = _props.selectedRows, fetchTableData = _props.fetchTableData, Clients = _props.Clients, bulkData = (0, _mobx.toJS)(selectedRows).map(function (row) {
                  return _extends({ id: row.case_id }, data);
                });
                _context.next = 3;
                return Clients.cases.updateBulk(bulkData);

              case 3:
                fetchTableData();

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function bulkUpdateCaseData(_x) {
        return _ref2.apply(this, arguments);
      }

      return bulkUpdateCaseData;
    }()
  }, {
    key: 'updateTrackingDate',
    value: function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(data) {
        var _props2, selectedRows, SessionStore;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _props2 = this.props, selectedRows = _props2.selectedRows, SessionStore = _props2.SessionStore;


                SessionStore.trackEvent('BULK_UPDATE_CASE_TRACKING_FOLLOWUP_DATE', { number_of_cases: selectedRows.length });
                _context2.next = 4;
                return this.bulkUpdateCaseData(data);

              case 4:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function updateTrackingDate(_x2) {
        return _ref3.apply(this, arguments);
      }

      return updateTrackingDate;
    }()
  }, {
    key: 'renderChangeFollowUpButton',
    value: function renderChangeFollowUpButton(_ref4) {
      var isVisible = _ref4.isVisible,
          isDisabled = _ref4.isDisabled;

      return isVisible && _react2.default.createElement(
        _Button2.default,
        { bsStyle: 'link', disabled: isDisabled, onClick: this.isChangeFollowupModalVisible.setTrue },
        _react2.default.createElement(_common.Icon, { type: 'calendar-o' }),
        ' Change Follow-Up'
      );
    }
  }, {
    key: 'renderBulkActionButtons',
    value: function renderBulkActionButtons() {
      var _props3 = this.props,
          isMightyFreeUser = _props3.isMightyFreeUser,
          FunderStore = _props3.FunderStore,
          selectedRows = _props3.selectedRows,
          SessionStore = _props3.SessionStore,
          showSharingButton = (0, _get3.default)(FunderStore, 'funder.has_private_cases', false),
          canCloseLiens = !!SessionStore.userHasPermission(PERMISSIONS.CLOSE_LIEN);


      return _react2.default.createElement(
        _ButtonToolbar2.default,
        { className: 'toolbar-bulk' },
        !selectedRows.length ? _react2.default.createElement(
          'div',
          { className: 'info empty' },
          '(Select cases for bulk update)'
        ) : _react2.default.createElement(
          _react.Fragment,
          null,
          _react2.default.createElement(
            'div',
            { className: 'info' },
            '(' + selectedRows.length + ')'
          ),
          this.renderChangeFollowUpButton({ isDisabled: !selectedRows.length, isVisible: !isMightyFreeUser }),
          showSharingButton && _react2.default.createElement(
            _Button2.default,
            { bsStyle: 'link', onClick: this.isSharingStatusModalVisible.setTrue },
            _react2.default.createElement(_common.Icon, { type: 'share' }),
            ' Change Sharing Status'
          ),
          canCloseLiens && _react2.default.createElement(
            _Button2.default,
            { bsStyle: 'link', onClick: this.isCloseAllLiensModalVisible.setTrue },
            _react2.default.createElement(_common.Icon, { type: 'arrow-circle-right' }),
            ' Close All Liens'
          ),
          _react2.default.createElement(
            _Button2.default,
            { bsStyle: 'link', onClick: this.isChangeOwnersModalVisible.setTrue },
            _react2.default.createElement(_common.Icon, { type: 'user' }),
            ' Change Owners'
          ),
          _react2.default.createElement(
            _Button2.default,
            { bsStyle: 'link', className: 'btn-change-tracking-contact', onClick: this.isChangeTrackingContactModalVisible.setTrue },
            _react2.default.createElement(_common.Icon, { type: 'address-book' }),
            ' Change Tracking Contact'
          )
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var selectedRows = this.props.selectedRows;


      return _react2.default.createElement(
        'header',
        null,
        _react2.default.createElement(
          'h1',
          null,
          'Portfolio'
        ),
        this.renderBulkActionButtons(),
        this.isChangeFollowupModalVisible.isTrue && _react2.default.createElement(_mightyFields.FormModal, {
          fieldSets: [[{ field: 'tracking_follow_up_date', type: 'date' }]],
          onClose: this.isChangeFollowupModalVisible.setFalse,
          onSave: this.updateTrackingDate,
          title: 'Schedule Case Tracking Update'
        }),
        this.isSharingStatusModalVisible.isTrue && _react2.default.createElement(_mightyFields.FormModal, {
          fieldSets: FIELD_SETS_CASE_SHARING_DROPDOWN,
          model: { migrate_to_registry: true },
          onClose: this.isSharingStatusModalVisible.setFalse,
          onSave: this.bulkUpdateCaseData,
          title: 'Case Sharing Status Update'
        }),
        _react2.default.createElement(_CloseAllLiensModal2.default, {
          isVisible: this.isCloseAllLiensModalVisible,
          selectedRows: selectedRows
        }),
        _react2.default.createElement(_ChangeOwnersModal2.default, {
          isVisible: this.isChangeOwnersModalVisible,
          onSave: this.bulkUpdateCaseData,
          selectedRows: selectedRows
        }),
        _react2.default.createElement(_ChangeTrackingContactModal2.default, {
          isVisible: this.isChangeTrackingContactModalVisible,
          onSave: this.bulkUpdateCaseData,
          selectedRows: selectedRows
        })
      );
    }
  }, {
    key: '__reactstandin__regenerateByEval',
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return CaseTrackingHeader;
}(_react.Component), _class3.propTypes = {
  Clients: _propTypes2.default.object.isRequired,
  fetchTableData: _propTypes2.default.func.isRequired,
  FunderStore: _propTypes2.default.object.isRequired,
  isMightyFreeUser: _propTypes2.default.bool.isRequired,
  onFilterOutCasesWithNoTrackingContacts: _propTypes2.default.func.isRequired,
  onSendRequestUpdates: _propTypes2.default.func.isRequired,
  selectedRows: _mobxReact.propTypes.arrayOrObservableArray.isRequired,
  SessionStore: _propTypes2.default.object.isRequired
}, _temp2), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'isChangeFollowupModalVisible', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return new _SmartBool2.default();
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, 'isSharingStatusModalVisible', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return new _SmartBool2.default();
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, 'isCloseAllLiensModalVisible', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return new _SmartBool2.default(false);
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, 'isChangeOwnersModalVisible', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return new _SmartBool2.default(false);
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, 'isChangeTrackingContactModalVisible', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return new _SmartBool2.default(false);
  }
})), _class2)) || _class) || _class) || _class);
var _default = CaseTrackingHeader;
exports.default = _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(PERMISSIONS, 'PERMISSIONS', '/app/src/components/page-case-tracking/CaseTrackingHeader.js');
  reactHotLoader.register(FIELD_SETS_CASE_SHARING_DROPDOWN, 'FIELD_SETS_CASE_SHARING_DROPDOWN', '/app/src/components/page-case-tracking/CaseTrackingHeader.js');
  reactHotLoader.register(CaseTrackingHeader, 'CaseTrackingHeader', '/app/src/components/page-case-tracking/CaseTrackingHeader.js');
  reactHotLoader.register(_default, 'default', '/app/src/components/page-case-tracking/CaseTrackingHeader.js');
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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